/**
 * Validation rules used in validation.js
 */


const validationRules = (() => {
    let _matching = {};

    /**
     * Set rule-logic matching
     */
    const init = () => {
        _matching = {
            required: required,
            phone: phone,
            name: name,
            email: email
        };
    };

    /**
     * Return matching rule
     * @param rule
     */
    const returnValidationRule = (rule) => {
        //TODO: add some element check/ parsing
        rule = rule.trim();
        return _matching[rule];
    };

    /**
     * required field validation test. Sometimes it can be a boolean value
     *
     * @param {String|Boolean|Array} value
     * @returns {boolean}
     */
    const required = (value, type) => {
        if (type !== "checkbox")
            value = value.replace(/\s+/g, '');

        if (!value) {
            return {
                error: true,
                msg: "This field is required"
            };
        }

        return {error: false};
    };

    /**
     * Name/surname validation test
     *
     * @param {String} value
     * @returns {Boolean}
     */
    const name = (value) => {
        return (/^[a-zżźćńółęąś\s\-]+$/i.test(value)) ? {error: false} : {
            error: true,
            msg: 'Pole może zawierać tylko litery'
        };
    };

    const email = (value) => {
        let polishLetters = /[ąĄćĆęĘłŁńŃóÓśŚźŹżŻ]/;

        if (value.indexOf("@") > -1) {
            let name = value.split('@')[0];

            if (name.length > 64) {
                return {
                    error: true,
                    msg: 'Invalid e-mail address'
                };
            }
        }

        if (value.match(polishLetters) !== null) {
            return {
                error: true,
                msg: 'Invalid e-mail address'
            };
        }

        if (!value) {
            return {
                error: true,
                msg: 'Invalid e-mail address'
            };
        }

        return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) ? {error: false} : {
            error: true,
            msg: 'Invalid e-mail address'
        };

    };

    const phone = (value) => {
        return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im.test(value) ? {error: false} : {
            error: true,
            msg: "Podany numer telefonu jest nieprawidłowy"
        };
    };

    return {
        init: init,
        returnValidationRule: returnValidationRule
    };
})();

export {validationRules}
